import { Set } from 'immutable';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { accessors as userAccessors } from 'data/Users';
import { Homework } from 'data/Homework';
import { actions as groupActions } from 'containers/Group';

const PUBLISHED = Homework.Status.PUBLISHED.toLowerCase();

function checkApplicableTeacherPrivileges(state, createdByUserId) {
  const loginUserId = userAccessors.getLoginUserId(state);
  const addPrivilege =
    PrivilegeChecker.hasPrivilege(state, Privileges.AssignHomework.ManageOwn);
  return addPrivilege && loginUserId === createdByUserId;
}

function checkApplicablePAPrivileges(state) {
  return PrivilegeChecker.hasPrivilege(state, Privileges.AssignHomework.EditAny);
}

function checkIsPersonalisedHomeworkNotPublished(state, phId) {
  const publishedHomework = state
    .get('rootReducer')
    .get('personalisedHomework')
    .get(phId);
  return publishedHomework.status.toLowerCase() !== PUBLISHED;
}

export function getSummary(state, sessionId) {
  const phSummary = state
    .get('rootReducer')
    .get('personalisedHomework')
    .reduce((summary, ph) => ({
      size: ph.sessionId === sessionId ? summary.size + 1 : summary.size,
      publishedSize: (ph.sessionId === sessionId && ph.status.toLowerCase() === PUBLISHED) ?
        summary.publishedSize + 1 : summary.publishedSize,
    }), { size: 0, publishedSize: 0 });
  return phSummary;
}

export function isExisty(state, sessionId) {
  const summary = getSummary(state, sessionId);
  return summary.size > 0;
}

export function isPublished(state, sessionId) {
  const summary = getSummary(state, sessionId);
  return summary.size !== 0 && summary.size === summary.publishedSize;
}

export function getPersonalisedHomeworkViewModel(state, groupId, phId, isInEditGroupHomeworkdMode) {
  const personalisedHomework = state.get('rootReducer').get('personalisedHomework').get(phId);
  const canEditOrDelete =
    ! groupActions.isAutoPublishHomework(state, groupId) &&
    checkIsPersonalisedHomeworkNotPublished(state, phId) &&
      (checkApplicableTeacherPrivileges(state, personalisedHomework.createdByUserId) ||
      checkApplicablePAPrivileges(state)) &&
      ! isInEditGroupHomeworkdMode;
  const personalisedHomeworkJs = personalisedHomework.toJS();
  return Object.assign(personalisedHomeworkJs, {
    canEdit: canEditOrDelete,
    canDelete: canEditOrDelete,
    // TODO: revisit this quick hack to make this work again
    studentIds: new Set(personalisedHomeworkJs.studentIds),
  });
}

export default getPersonalisedHomeworkViewModel;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Personalised/accessors.js